import React from 'react';
import { getProductClass } from './catalog';
import ProductPrice from './ProductPrice';
import { propertyIcon } from './PropertyIcons';

const ArrowLeftIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
    <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
  </svg>
);

// Widok detali produktu – oddzielny „ekran” renderowany na podstawie danych z katalogu.
// Sekcja „Właściwości” to płaska lista 4 krótkich właściwości (product.properties);
// każda ma własną ikonę PNG dobieraną po słowie kluczowym (zob. PropertyIcons).
const ProductDetail = React.memo(function ProductDetail({ product }) {
  const backHref = '#sklep';
  const properties = product.properties || [];

  return (
    <section className={`detail-section ${getProductClass(product.name)}`}>
      <div className="detail-topbar">
        <a href={backHref} className="detail-back-btn">
          <ArrowLeftIcon />
          Powrót
        </a>
      </div>

      <div className="detail-panel">
        <div className="detail-image-frame">
          <img src={product.img} alt={product.name} decoding="async" />
        </div>

        <div className="detail-info">
          <h1 className="detail-title">{product.name}</h1>
          <div className="premium-line-divider"></div>

          {properties.length > 0 && (
            <>
              <h2 className="detail-subtitle">Właściwości</h2>
              <ul className="detail-properties">
                {properties.map((text, index) => (
                  <li key={index} className="detail-property">
                    <span className="detail-fact-icon" aria-hidden="true">
                      <img src={propertyIcon(text)} alt="" loading="lazy" />
                    </span>
                    <span className="detail-property-text">{text}</span>
                  </li>
                ))}
              </ul>
            </>
          )}

          <ProductPrice options={product.options} />
        </div>
      </div>
    </section>
  );
});

export default ProductDetail;